import React from 'react'
import propTypes from 'prop-types'
import { Card, CardActionArea, Typography, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
	card: {
		height: '100%',
		minHeight: 130,
		border: `1px solid ${theme.palette.divider}`,
		transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
		'&:hover': {
			borderColor: theme.palette.primary.light
		}
	},
	cardSelected: {
		borderColor: theme.palette.primary.main,
		borderWidth: 2
	},
	cardDisabled: {
		opacity: 0.5,
		'&:hover': {
			borderColor: theme.palette.divider
		}
	},
	cardArea: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		gap: theme.spacing(0.5),
		padding: theme.spacing(2),
		textAlign: 'center'
	},
	icon: {
		fontSize: 36,
		color: theme.palette.primary.main,
		marginBottom: theme.spacing(0.5)
	},
	title: {
		fontWeight: 600,
		color: theme.palette.primary.main
	},
	description: {
		color: theme.palette.text.secondary
	}
}))

const TypeCard = ({ icon: Icon, title, description, onClick, datacy, disabled, selected }) => {
	const classes = useStyles()
	const cardClasses = [classes.card]
	if (selected) cardClasses.push(classes.cardSelected)
	if (disabled && !selected) cardClasses.push(classes.cardDisabled)

	return (
		<Card className={cardClasses.join(' ')} elevation={0}>
			<CardActionArea
				className={classes.cardArea}
				onClick={disabled ? undefined : onClick}
				disabled={disabled}
				data-cy={datacy}
			>
				{Icon && <Icon className={classes.icon} color='primary' />}
				<Typography variant='subtitle1' className={classes.title}>
					{title}
				</Typography>
				<Typography variant='caption' className={classes.description}>
					{description}
				</Typography>
			</CardActionArea>
		</Card>
	)
}

TypeCard.propTypes = {
	icon: propTypes.elementType,
	title: propTypes.string.isRequired,
	description: propTypes.string.isRequired,
	onClick: propTypes.func.isRequired,
	datacy: propTypes.string,
	disabled: propTypes.bool,
	selected: propTypes.bool
}

TypeCard.defaultProps = {
	disabled: false,
	selected: false
}

export default TypeCard
